export default "__VITE_ASSET__RrwwUkvm__"